var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "max-w-3xl mx-auto" }, [
    _c(
      "div",
      { staticClass: "mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6" },
      [
        _c("label", { staticClass: "text-base font-medium text-gray-900" }, [
          _vm._v("Manual Message Sending Preference")
        ]),
        _c("p", { staticClass: "text-sm leading-5 text-gray-500" }, [
          _vm._v(
            " You can either choose to send manual messages using whatsapp web or desktop app "
          )
        ]),
        _c("fieldset", { staticClass: "mt-4" }, [
          _c("legend", { staticClass: "sr-only" }, [_vm._v("Method")]),
          _c(
            "div",
            { staticClass: "space-y-4" },
            _vm._l(_vm.options, function(option, index) {
              return _c(
                "div",
                { key: index, staticClass: "flex items-center" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.sendMessagesUsingDesktopApp,
                        expression: "sendMessagesUsingDesktopApp"
                      }
                    ],
                    staticClass:
                      "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300",
                    attrs: {
                      id: "pref_" + index,
                      name: "notification-method",
                      type: "radio"
                    },
                    domProps: {
                      value: option.value,
                      checked: _vm._q(
                        _vm.sendMessagesUsingDesktopApp,
                        option.value
                      )
                    },
                    on: {
                      input: function($event) {
                        return _vm.updatePreference(option.value)
                      },
                      change: function($event) {
                        _vm.sendMessagesUsingDesktopApp = option.value
                      }
                    }
                  }),
                  _c(
                    "label",
                    {
                      staticClass:
                        "ml-3 block text-sm font-medium text-gray-700",
                      attrs: { for: "pref_" + index }
                    },
                    [_vm._v(" " + _vm._s(option.label) + " ")]
                  )
                ]
              )
            }),
            0
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }